var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"toast-plugins",class:("toast-" + _vm.type),domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }